export const getTenantNameFromUrl = (href: string) => {
	const url = new URL(href);

	const name = url.hostname.split('.')[0];
	if (!name) throw new Error('No tenant name found in url');
	return name;
};

export const getTenantNameFromWindow = () =>
	getTenantNameFromUrl(window.location.href);

export const isUrlDev = (href: string) => href.includes('.dev.');
